import { Footer, Header } from "@/design-system/Organisms"
import { headerConfig } from "@/design-system/Organisms/Header/Header.config"
import { MainLayout } from "@/design-system/Templates"
import CheckoutPageTemplate from "@/design-system/Templates/CheckoutPageTemplate"
import { useScrollToTopOnMount } from "@/hooks/useScrollToTopOnMount"

const CheckoutPage = () => {
    useScrollToTopOnMount()

    return (
        <MainLayout
            header={<Header {...headerConfig} />}
            sidebar={null}
            className=""
            footer={<Footer />}
            topBanner={null}
        >
            <CheckoutPageTemplate />
        </MainLayout>
    )
}

export default CheckoutPage